import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../service/api";

export const fetchMonthlyReportById = createAsyncThunk(
  "reports/fetchMonthlyReportById",
  async (reportId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`api/reports/monthly/${reportId}`);

      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch monthly report"
      );
    }
  }
);

export const generateMonthlyReportAISummary = createAsyncThunk(
  "reports/generateMonthlyReportAISummary",
  async (report, { rejectWithValue }) => {
    try {
      const { data } = await api.post("api/reports/monthly/summary", {
        report,
      });
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to generate AI summary"
      );
    }
  }
);

export const getQRFunnelRecommendations = createAsyncThunk(
  "ai/qrFunnel",
  async (qrOverview, { rejectWithValue }) => {
    try {
      const { data } = await api.post("api/reports/monthly/recomendations", {
        qrOverview,
      });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const monthlyReports = createSlice({
  name: "reportAISummary",
  initialState: {
    report: null,
    reportLoading: false,
    reportError: null,

    recommendations: [],
    recomendationsLoading: false,
    recommendationsError: null,

    loading: false,
    success: false,
    error: null,
    summary: null,
  },
  reducers: {
    resetReportAISummary: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.summary = null;
    },
  },
  extraReducers: (builder) => {
    // Get monthly reports data
    builder
      .addCase(fetchMonthlyReportById.pending, (state) => {
        state.reportLoading = true;
        state.reportError = null;
      })
      .addCase(fetchMonthlyReportById.fulfilled, (state, action) => {
        state.reportLoading = false;
        state.report = action.payload?.data || null;
      })
      .addCase(fetchMonthlyReportById.rejected, (state, action) => {
        state.reportLoading = false;
        state.reportError = action.payload;
      });

    // Generate AI summary for monthly reports
    builder

      .addCase(generateMonthlyReportAISummary.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
        state.summary = null;
      })

      .addCase(generateMonthlyReportAISummary.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.summary = action.payload.summary;
      })

      .addCase(generateMonthlyReportAISummary.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });

    // Generate AI recomendations for QR code funnel
    builder
      .addCase(getQRFunnelRecommendations.pending, (state) => {
        state.recomendationsLoading = true;
      })
      .addCase(getQRFunnelRecommendations.fulfilled, (state, action) => {
        state.recomendationsLoading = false;
        state.recommendations = action.payload.recommendations;
      })
      .addCase(getQRFunnelRecommendations.rejected, (state, action) => {
        state.recomendationsLoading = false;
        state.recommendationsError = action.payload;
      });
  },
});

export const { resetReportAISummary } = monthlyReports.actions;
export default monthlyReports.reducer;
